let _used = false;
export function gpsUsed(): boolean {
    return _used;
}
export function markGpsUsed(): void {
    _used = true;
}
export function resetGps(): void {
    _used = false;
    gpsGlobalCodes.clear();
}

export const gpsGlobalCodes = new Map<string, string>();

export function gpsGlobalCode(rx: number, tx: number): string {
    return `TinyGPSPlus _sbeGps_${tx};\nSoftwareSerial _sbeGpsSerial_${tx}(${rx}, ${tx});\nbool _sbeGpsWarned_${tx} = false;\n`;
}

export function gpsGlobalCodeBlue(tx: number): string {
    return `TinyGPSPlus _sbeGps_${tx};\nbool _sbeGpsWarned_${tx} = false;\n`;
}

export const GPS_POSITION_LABELS: Record<string, string> = {
    UPPER_LEFT: '左上',
    UPPER_RIGHT: '右上',
    LOWER_LEFT: '左下',
    LOWER_RIGHT: '右下',
};

export const GPS_BASE_HELPER_CODE = `const char* _sbeGpsWaitMsg = "GPSセンサーを起動しています。使用できるまで2〜10分かかります。しばらくお待ちください。";

void _sbeGpsBegin(SoftwareSerial* serial, const char* label) {
  serial->begin(9600);
  Serial.print("[GPS ");
  Serial.print(label);
  Serial.print("] ");
  Serial.println(_sbeGpsWaitMsg);
}

void _sbeGpsCheckAge(TinyGPSPlus* gps, SoftwareSerial* serial, bool* warned, const char* label) {
  while (serial->available() > 0) {
    gps->encode(serial->read());
  }
  if (gps->location.isValid() && gps->location.age() > 5000 && !*warned) {
    Serial.print("[GPS ");
    Serial.print(label);
    Serial.println("] センサーの信号を正しく受信できていない可能性があります。");
    *warned = true;
  }
}`;

export const GPS_BASE_HELPER_CODE_BLUE = `const char* _sbeGpsWaitMsg = "GPSセンサーを起動しています。使用できるまで2〜10分かかります。しばらくお待ちください。";

void _sbeGpsBegin_blue(const char* label) {
  Serial.print("[GPS ");
  Serial.print(label);
  Serial.print("] ");
  Serial.println(_sbeGpsWaitMsg);
}

void _sbeGpsCheckAge_blue(TinyGPSPlus* gps, bool* warned, const char* label) {
  while (Serial2.available() > 0) {
    gps->encode(Serial2.read());
  }
  if (gps->location.isValid() && gps->location.age() > 5000 && !*warned) {
    Serial.print("[GPS ");
    Serial.print(label);
    Serial.println("] センサーの信号を正しく受信できていない可能性があります。");
    *warned = true;
  }
}`;
